import {
  NatureBreakdown,
  PublicProfile,
} from "@dimensional-engineering/dimensional-models";

import styles from "./PublicProfilesNatureBreakdown.module.css";

import { natureData } from "@/assets/traitInfo/natureData";
import InformationIcon from "@/components/premium/reports/blindspot/ReportAccuracy/InformationIcon";
import PublicProfilesGhostBox from "../PublicProfilesGhostBox/PublicProfilesGhostBox";

export default function PublicProfilesNatureBreakdown(props: {
  publicProfile: PublicProfile;
}) {
  return (
    <div className={styles.main}>
      <PublicProfilesInfoBubble
        title={
          "Our Nature is our fundamental vibe. It's what feels most authentic to us and the energy we present to the outer world."
        }
      />
      {props.publicProfile.primaryNature?.nature ? (
        <div className={styles.wrapper}>
          <NatureRow publicProfile={props.publicProfile} natureSlug="chaos" />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="energyAndExcitement"
          />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="opennessAndIntellect"
          />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="orderAndStructure"
          />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="selfEnhancement"
          />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="warmthAndAgreeableness"
          />
          <NatureRow
            publicProfile={props.publicProfile}
            natureSlug="tranquility"
          />
        </div>
      ) : (
        <PublicProfilesGhostBox />
      )}
    </div>
  );
}

function NatureRow(props: {
  natureSlug: string;
  publicProfile: PublicProfile;
}) {
  const nature = natureData?.find((n) => n.slug === props.natureSlug);

  if (!nature) {
    return <></>;
  }

  const score =
    props.publicProfile.primaryNature?.natureBreakdown[
      props.natureSlug as keyof NatureBreakdown
    ];

  return (
    <div className={styles.row}>
      <div className={styles.rowTop}>
        <div
          style={{ backgroundColor: `${nature.color}` }}
          className={styles.circle}
        ></div>
        <h4 className={styles.rowTitle}>{nature.name}</h4>
      </div>
      <p className={styles.rowDesc}>{nature.shortDescription}</p>
      <div className={styles.rowScoreWrapper}>
        <div
          style={
            score !== undefined ? { width: `${score * 100}%` } : { width: "0%" }
          }
          className={styles.rowScore}
        ></div>
      </div>
    </div>
  );
}

export function PublicProfilesInfoBubble(props: { title: string }) {
  return (
    <div className={styles.infoDiv}>
      <p className={styles.infoText}>{props.title}</p>
      <div className={styles.infoIcon}>
        <InformationIcon />
      </div>
    </div>
  );
}
